import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { SpinnerComponent } from 'src/app/components/helpers/spinner/spinner.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  overlayRef: OverlayRef;

  constructor(private overlay: Overlay) {
    this.overlayRef = overlay.create();
   }

  show(){
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically()
    })
    const comp = new ComponentPortal(SpinnerComponent);
    this.overlayRef.attach(comp);
  }

  hide() {
    this.overlayRef.detach();
  }
}
